import { AdsList } from '../pages/AdsManagement/AdsList'
import { BannerList } from '../pages/Banner/BannerList'
import { BeadsList } from '../pages/BeadsManager/BeadsList'
import { BlogList } from '../pages/Blog/BlogList'
import { CountryList } from '../pages/Country/CountryList'
import { Dashboard } from '../pages/Dashboard'
import { EffectsList } from '../pages/Effects/EffectsList'
import { EmailList } from '../pages/Email/EmailList'
import { PackagesList } from '../pages/InAppPurchase/PackagesList'
import { FaqList } from '../pages/FAQ/FaqList'
import { FilterList } from '../pages/Filter/FilterList'
import { FontStyleList } from '../pages/FontStyle/FontStyleList'
import { GeoLocationList } from '../pages/GeoLocation/GeoLocationList'
import { GlobalSettingList } from '../pages/GlobalSetting/GlobalSettingList'
import { Login } from '../pages/Login'
import { NotificationList } from '../pages/Notification/NotificationList'
import { EditProfile } from '../pages/Profile/EditProfile'
import { RateList } from '../pages/Rate/RateList'
import { ReportAbuseList } from '../pages/ReportAbuse/ReportAbuseList'
import { RoleList } from '../pages/Role/RoleList'
import { SoundList } from '../pages/Sound/SoundList'
import { StateList } from '../pages/StateManager/StateList'
import { StaticList } from '../pages/Static/StaticList'
import { StickerList } from '../pages/Sticker/StickerList'
import { StreamingList } from '../pages/Streaming/StreamingList'
import { SubAdminList } from '../pages/SubAdmin/SubAdminList'
import { TagsList } from '../pages/Tags/TagsList'
import { TransactionList } from '../pages/Transaction/TransactionList'
import { UserDetails } from '../pages/User/UserDetails'
import { UserList } from '../pages/User/UserList'
import { VideoList } from '../pages/Video/VideoList'
import { WidgetList } from '../pages/Widget/WidgetList'
import { WithdrawList } from '../pages/Withdraw/WithdrawList'
import { CityList } from '../pages/CityManager/CityList'
import { DistrictList } from '../pages/DistrictManager/DistrictList'
import { LanguageList } from '../pages/Language/LanguageList'
import { InfluencerList } from '../pages/Influencer/InfluencerList'
import { InfluencerCategoryList } from '../pages/InfluencerCategory/InfluencerCategoryList'
import { PromoVideoList } from '../pages/PromoVideoManager/PromoVideoList'
import { PackageList } from '../pages/SubscriptionPackage/PackageList'
import { ViewerSubscriptionList } from '../pages/ViewerSubscription/ViewerSubscriptionList'
import { GenerateBotAccount } from '../pages/BotAccount/GenerateBotAccount'
import { BotAccountUserList } from '../pages/BotAccount/BotAccountUserList'
import { VideoUploadList } from '../pages/VideoUploadManager/VideoUploadList'
import UploadVideo from '../pages/VideoUploadManager/UploadVideo'
import { NetworkProviersList } from '../pages/NetworkProviders/NetworkProviersList'
import { CountryRoutingList } from '../pages/RoutingManager/CountryRoutingList'
import { AddCountryRoutingConfig } from '../pages/RoutingManager/AddCountryRoutingConfig'
import { LiveReelCategoryList } from '../pages/LiveReelCategory/LiveReelCategoryList'
import { RadioList } from '../pages/RadioManager/RadioList'
import { List } from '../pages/PaymentGateway/List'
import { BusinessCategoryList } from '../pages/BusinessCategory/List'
import { BusinessMerchantList } from '../pages/BusinessMerchant/List'
import ViewBusinessDetails from '../pages/BusinessMerchant/ViewBusinessDetails'
import { AgentList } from '../pages/Agents/List'
import { ViewAgentsDetails } from '../pages/Agents/ViewAgentsDetails'
import { AgencyList } from '../pages/AgencyManager/List'
import { ViewAgencyDetails } from '../pages/AgencyManager/ViewAgencyDetails'
import { RidersList } from '../pages/Riders/List'
import { ViewRiderDetails } from '../pages/Riders/ViewRiderDetails'
import { VehicleCategory } from '../pages/VehicleCategory/VehicleCategory'
import NewsFeedsList from '../pages/NewsFeeds/NewsFeedsList'
import NewsCategoryList from '../pages/NewsCategory/NewsCategoryList'
import ProductList from '../pages/Productmanager/ProductList'
import { ProductCategoryList } from '../pages/ProductCategory/List'
import { TaxTemplatesList } from '../pages/TaxTemplatesManager/List'

import AyrshareManager from '../pages/AyrshareManager/List'
import AyrshareManagerView from '../pages/AyrshareManager/View'
import { MerchantRiderSubscriptionList } from '../pages/MerchantRiderSubscription/List'
import { MerchantSubscriptionPlansList } from '../pages/MerchantSubscriptionPlans/MerchantSubscriptionPlansList'
import { AffiliateUsersList } from '../pages/AffiliateUsers/List'
import { ViewAffiliateUsersDetails } from '../pages/AffiliateUsers/ViewAffiliateUsersDetails'
import ServiceList from '../pages/Services/List'
import { VodList } from '../pages/Vod/List'
import { DiscountVouchersList } from '../pages/DiscountVouchers/DiscountVouchersList'
import { AddEditDiscountVoucher } from '../pages/DiscountVouchers/AddEditDiscountVoucher'
import { DiscountVoucherConfig } from '../pages/DiscountVouchers/DiscountVoucherConfig'
import { ProductDiscountList } from '../pages/ProductDiscount/ProductDiscountList'
import SearchOtp from '../pages/SearchOtp/SearchOtp'

export const nav = [
  {
    path: '/',
    name: 'Dashboard',
    element: <Dashboard />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/edit-profile',
    name: 'Edit Profile',
    element: <EditProfile />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/role-manager',
    name: 'Role Manager',
    element: <RoleList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/promo-video-manager',
    name: 'Promo Video Manager',
    element: <PromoVideoList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-manager',
    name: 'User Manager',
    element: <UserList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-manager/:id',
    name: 'User Details Manager',
    element: <UserDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/sub-admin-manager',
    name: 'Sub Admin Manager',
    element: <SubAdminList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/filter-manager',
    name: 'Filter Manager',
    element: <FilterList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/font-style-manager',
    name: 'Font & Style Manager',
    element: <FontStyleList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/effect-manager',
    name: 'Effect Manager',
    element: <EffectsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/sound-manager',
    name: 'Sound Manager',
    element: <SoundList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/widget-manager',
    name: 'Widgets Manager',
    element: <WidgetList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/report-abuse-manager',
    name: 'Report Abuse Manager',
    element: <ReportAbuseList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/beads-purchase-manager',
    name: 'Chips Purchase Manager',
    element: <BeadsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/video-manager',
    name: 'Video Manager',
    element: <VideoList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/streaming-manager',
    name: 'Video Manager',
    element: <StreamingList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/transaction-manager',
    name: 'Transaction Manager',
    element: <TransactionList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/app_packages-manager',
    name: 'In App Packages Manager',
    element: <PackagesList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/notification-manager',
    name: 'Notification Manager',
    element: <NotificationList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/live-feed-category-manager',
    name: 'Live Feed Category Manager',
    element: <LiveReelCategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/radio-manager',
    name: 'Radio Manager',
    element: <RadioList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/routing-manager',
    name: 'Routing Manager',
    element: <CountryRoutingList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/payment-gateway-manager',
    name: 'Payment Gateway Manager',
    element: <List />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/add-routing-config',
    name: 'Add Routing Config',
    element: <AddCountryRoutingConfig />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/network-provider-manager',
    name: 'Network Provider Manager',
    element: <NetworkProviersList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/country-manager',
    name: 'Country Manager',
    element: <CountryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/state-manager',
    name: 'State Manager',
    element: <StateList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/tax-templates-manager',
    name: 'Tax Templates Manager',
    element: <TaxTemplatesList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/city-manager',
    name: 'City Manager',
    element: <CityList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/bot-manager',
    name: 'Bot Manager',
    element: <BotAccountUserList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/bot-manager/generate',
    name: 'Bot Manager',
    element: <GenerateBotAccount />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/video-upload-manager',
    name: 'Video Upload Manager',
    element: <VideoUploadList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/video-upload-manager/upload',
    name: 'Video Upload Manager',
    element: <UploadVideo />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/news-feeds',
    name: 'News Manager',
    element: <NewsFeedsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/news-feeds-category-manager',
    name: 'News Category Manager',
    element: <NewsCategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/district-manager',
    name: 'District Manager',
    element: <DistrictList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/email-manager',
    name: 'Email Manager',
    element: <EmailList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/product-manager',
    name: 'Product Manager',
    element: <ProductList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/discount-vouchers-manager',
    name: 'Discount Vouchers Manager',
    element: <DiscountVouchersList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/add-discount-voucher',
    name: 'Add Discount Voucher',
    element: <AddEditDiscountVoucher />,
    isMenu: false,
    isPrivate: true
  },
  {
    path: '/edit-discount-voucher/:id',
    name: 'Edit Discount Voucher',
    element: <AddEditDiscountVoucher />,
    isMenu: false,
    isPrivate: true
  },
  {
    path: '/discount-voucher-config',
    name: 'Discount Voucher Unit Configuration',
    element: <DiscountVoucherConfig />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/product-discount-list',
    name: 'Product Discount List',
    element: <ProductDiscountList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/service-manager',
    name: 'Service Manager',
    element: <ServiceList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/global-setting-manager',
    name: 'Global Setting Manager',
    element: <GlobalSettingList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/static-content-manager',
    name: 'Static Content Manager',
    element: <StaticList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/geo-location-manager',
    name: 'Geo Location Manager',
    element: <GeoLocationList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/ads-manager',
    name: 'Ads Manager',
    element: <AdsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/blog-manager',
    name: 'Blog Manager',
    element: <BlogList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/tag-manager',
    name: 'Tags Manager',
    element: <TagsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/business-category-manager',
    name: 'Business Category Manager',
    element: <BusinessCategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/product-category-manager',
    name: 'Product Category Manager',
    element: <ProductCategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/business-merchant-details/:id',
    name: 'Business Merchant Details',
    element: <ViewBusinessDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/agents-details/:id',
    name: 'Agents Details',
    element: <ViewAgentsDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/agency-details/:id',
    name: 'Agency Details',
    element: <ViewAgencyDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/rider-details/:id',
    name: 'Rider Details',
    element: <ViewRiderDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/affiliate-user-details/:id',
    name: 'Affiliate User Details',
    element: <ViewAffiliateUsersDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/business-merchant-manager',
    name: 'Merchant Manager',
    element: <BusinessMerchantList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/agents-manager',
    name: 'Agents Manager',
    element: <AgentList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/agency-manager',
    name: 'Agency Manager',
    element: <AgencyList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/riders-manager',
    name: 'Riders Manager',
    element: <RidersList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/affiliate-user-manager',
    name: 'Affiliate Manager',
    element: <AffiliateUsersList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/influencer-category-manager',
    name: 'Influencer Category Manager',
    element: <InfluencerCategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/language-manager',
    name: 'Language Manager',
    element: <LanguageList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/influencer-manager',
    name: 'Influencer Manager',
    element: <InfluencerList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/faq-manager',
    name: 'FAQ Manager',
    element: <FaqList />,
    isMenu: true,
    isPrivate: true
  },
  // {
  //   path: '/vod-manager',
  //   name: 'VOD Manager',
  //   element: <VodList />,
  //   isMenu: true,
  //   isPrivate: true
  // },
  // {
  //   path: '/rating-manager',
  //   name: 'Rate Application Manager',
  //   element: <RateList />,
  //   isMenu: true,
  //   isPrivate: true
  // },
  {
    path: '/withdraw-manager',
    name: 'Withdraw Manager',
    element: <WithdrawList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/banner-manager',
    name: 'Banner Manager',
    element: <BannerList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/merchant-rider-subscription-manager',
    name: 'MerchantRiderSubscription Manager',
    element: <MerchantRiderSubscriptionList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/merchant-subscription-plans',
    name: 'Merchant Subscription Plans',
    element: <MerchantSubscriptionPlansList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/vehicle-category-manager',
    name: 'Vehicle Category Manager',
    element: <VehicleCategory />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/meishe-assets-manager',
    name: 'Meishe Assets',
    element: <StickerList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/login',
    name: 'Login',
    element: <Login />,
    isMenu: true,
    isPrivate: false
  },
  {
    path: '/subscription-package',
    name: 'Subscription Package',
    element: <PackageList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/viewer-subscription-manager',
    name: 'Viewer Subscription Manager',
    element: <ViewerSubscriptionList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/ayrshare-manager',
    name: 'Ayrshare Manager',
    element: <AyrshareManager />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/ayrshare-manager/:userId',
    name: 'Ayrshare Manager Details',
    element: <AyrshareManagerView />,
    isMenu: false,
    isPrivate: true
  },
  {
    path: '/search-otp',
    name: 'Search OTP',
    element: <SearchOtp />,
    isMenu: false,
    isPrivate: true
  }
]
